import {Component, Input, OnInit} from '@angular/core';

/**
 * Generated class for the SelionsLegendComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'sellions-legend',
  templateUrl: 'sellions-legend.html'
})
export class SellionsLegendComponent implements OnInit {
  @Input() legendValues: Array<any>;
  @Input() legendLabels;
  @Input() legendAmount;
  @Input() legendChange;
  @Input() legendColors: Array<any>;
  @Input() legendUnits;
  @Input() legendInfo;

  constructor() {
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/shared/components/sellions-legend/sellions-legend.ts